import { defineStore } from 'pinia'

import getters from '@/stores/getters'
import actions from '@/stores/actions'

export const store = defineStore('store', {
  state: () => {
    return {
      appTranslations: {},
      currentPartner: 'demo'
    }
  },
  getters,
  actions
})
